import { render, staticRenderFns } from "./KycPage.vue?vue&type=template&id=0c3e63ae&"
import script from "./KycPage.vue?vue&type=script&lang=js&"
export * from "./KycPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports